import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LinearLayouts.commonHtml.mjs';
import {
  ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement,
  Companion_getInstanceztgx4sy4wjnt as Companion_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/NativeElement.mjs';
import {
  DangerTextSemantic_getInstancetznd91yayzn7 as DangerTextSemantic_getInstance,
  ChipSemantic_getInstancen74y1gyt9zmo as ChipSemantic_getInstance,
  styledHeaderwng1nfqibdig as styledHeader,
} from '../../theme/semantics.mjs';
import {
  themed2vu67ornd4jps as themed,
  get_bold3d63kt1t4c9r5 as get_bold,
  dynamicThemed3lsusnjffkq9e as dynamicThemed,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import {
  ButtonSemantic_getInstance3q30xblp6a1af as ButtonSemantic_getInstance,
  ImportantSemantic_getInstancehm7lt56tp87l as ImportantSemantic_getInstance,
  DangerSemantic_getInstance1xd9zwrvs99lp as DangerSemantic_getInstance,
  HeaderSemantic_getInstance20a9id3sf7d4x as HeaderSemantic_getInstance,
  get_H1Semantic28sytsa4fm6nk as get_H1Semantic,
  CardSemantic_getInstancelcny5le8pbc4 as CardSemantic_getInstance,
  SubtextSemantic_getInstance1duu1ll1kgx8d as SubtextSemantic_getInstance,
  WarningSemantic_getInstance3kp0xfef7wnw4 as WarningSemantic_getInstance,
  AffirmativeSemantic_getInstance2svzxainpava5 as AffirmativeSemantic_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { Button263cw152yl80e as Button } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  TextView$_get_content_$ref_4pzcwl5a4gnldk8ef9 as TextView$_get_content_$ref_4pzcwl,
  TextView$_set_content_$ref_pketfb11e282hr0m0jl as TextView$_set_content_$ref_pketfb,
} from '../../App.mjs';
import {
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
  constructCallableReference23y65rf941mch as constructCallableReference,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  Button$_get_enabled_$ref_61t7nx58ibx9ifxb3n as Button$_get_enabled_$ref_61t7nx,
  Button$_set_enabled_$ref_o8kynzfmpduwei6tot as Button$_set_enabled_$ref_o8kynz,
} from './FamilyApplicationDetailPage.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Action2nhdpxpznfsbd as Action } from '../../../../../../kiteui-library/com/lightningkite/kiteui/reactive/Action.mjs';
import {
  weight31wqab1913ly4 as weight,
  shownWhen3t7othivfr11 as shownWhen,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import { onClick3gjrd4jjo1cak as onClick } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import { get_currentSessionNotNull30vuua77prq38 as get_currentSessionNotNull } from '../../sdk/currentSession.mjs';
import { AppState_getInstance33x03n2an9aul as AppState_getInstance } from '../../../../../../kiteui-library/com/lightningkite/kiteui/reactive/AppState.js.mjs';
import { get_stringsy7vodl9dj0ya as get_strings } from '../../strings.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import {
  Companion_instance1lm8x0jadqh2g as Companion_instance,
  Platform_Web_getInstance2840w5bkfolz8 as Platform_Web_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/Platform.mjs';
import { get_current2r182tjucmm5v as get_current } from '../../../../../../kiteui-library/com/lightningkite/kiteui/Platform.js.mjs';
import {
  await1uwe8zvsjq69o as await_0,
  await1xlt6i5aa076q as await_1,
} from '../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import {
  Review67dmpz2u77tw as Review,
  ProviderApplicationReviewRequest326rqs1sxt5sx as ProviderApplicationReviewRequest,
  ID3deomyff8nvpw as ID,
  ProviderApplicationj6elx51glw3 as ProviderApplication,
  ProviderApplicationSubmitRequest3hnpihftgb2vb as ProviderApplicationSubmitRequest,
  Submission2bovrq8ym2prz as Submission,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/applications.mjs';
import { toast4hp3bb4ymp24 as toast } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/popoverHelpers.mjs';
import { confirmationDialoginprr3lfvaqc as confirmationDialog } from '../components/dialogs.mjs';
import { get_pageNavigatorp3to6r4j8ctv as get_pageNavigator } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Navigator.mjs';
import { ProviderDetailPagemo61e65yggj8 as ProviderDetailPage } from '../providers/ProviderDetailPage.mjs';
import {
  ID1m87d1hextx54 as ID_0,
  CareProvider2qcawrqluyllr as CareProvider,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/domain.mjs';
import { ModificationBuilder10ot0rvxki4iq as ModificationBuilder } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/ModificationBuilder.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializerOrContextual2mm942ha7plg6 as serializerOrContextual } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/SerializationHelpers.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { DataClassPathSelf18kqeagzkbefr as DataClassPathSelf } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/DataClassPath.mjs';
import {
  get_submission3ha7ltsjel3fd as get_submission,
  get_provider3ji4mrhteqv5h as get_provider,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/ModelFields-372156621.mjs';
import { get_issues1z1skb5sgeygq as get_issues } from '../../../../../../reactive/com/lightningkite/reactive/lensing/validation/Validated.mjs';
import { Formjae7dnqjclc3 as Form } from '../components/form.mjs';
import { Draftj5auffrm1u2b as Draft } from '../../../../../../reactive/com/lightningkite/reactive/core/Draft.mjs';
import { validated2q9ie09qg9r46 as validated } from '../../../../../../reactive/com/lightningkite/reactive/lensing/validation/ValidatedDraft.mjs';
import {
  lensPath21i5dxhjzuxep as lensPath,
  lensPath3fz41zcs9wh0z as lensPath_0,
} from '../../../../../../lightning-server-kiteui-client/com/lightningkite/serialization/MutableReactive.lens.DataClassPath.mjs';
import { notNull1cr24slx2d4vw as notNull } from '../../../../../../reactive/com/lightningkite/reactive/extensions/commonLenses.mjs';
import { mutableRemember1h6fyyolumj0o as mutableRemember } from '../../../../../../reactive/com/lightningkite/reactive/core/MutableRemember.mjs';
import {
  EmailAddress__toString_impl_artjh3fv1lb2pg4oqn as EmailAddress__toString_impl_artjh3,
  EmailAddress1cvm8sbtoer9i as EmailAddress,
  PhoneNumber__toString_impl_7i2x3q2my82bpxyutrq as PhoneNumber__toString_impl_7i2x3q,
  PhoneNumber16oapr4wkp1a5 as PhoneNumber,
} from '../../../../../../service-abstractions-data-shared/com/lightningkite/services/data/StringAlts.mjs';
import { remember2m0mx1b5ra75q as remember } from '../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import { ReactiveState__getOrNull_impl_1asnfp338k3yl4xmyxq as ReactiveState__getOrNull_impl_1asnfp } from '../../../../../../reactive/com/lightningkite/reactive/core/ReactiveState.mjs';
import {
  get_scrolling3fwkltztkpfe8 as get_scrolling,
  sizeConstraints19w9rda6g3rqz as sizeConstraints,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import {
  maxWidth22r11xnm7d4h4 as maxWidth,
  goBackButton1g9k0xsmfm57i as goBackButton,
  keyValue1ck7xpd7fxylw as keyValue,
  iconButton2nzpucy7a6ixd as iconButton,
  reactiveLabel206b3aonybuoa as reactiveLabel,
} from '../components/view-utilities.mjs';
import {
  get_centered31th09q7x90sf as get_centered,
  get_atBottomCenter25gz8knna6ld8 as get_atBottomCenter,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { Separator36hc2oubnyjy3 as Separator } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Separator.commonHtml.mjs';
import { validatedmmpm5lnzq3lm as validated_0 } from '../../../../../../reactive/com/lightningkite/reactive/lensing/validation/entrypoints.mjs';
import { providerForm1foiubykcediz as providerForm } from '../providers/providerComponents.mjs';
import { renderToStringprxvmjepz2st as renderToString } from '../../../../../../kiteui-library/com/lightningkite/kiteui/locale/LocalTimeRender.mjs';
import { get_rem2p56fiaxda5jo as get_rem } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { Companion_getInstance23x6zslwzj0st as Companion_getInstance_0 } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { get_edit5ty08lpw30d6 as get_edit } from '../../icons.mjs';
import { get_waitForNotNull1jl9mx6el51tq as get_waitForNotNull } from '../../../../../../reactive/com/lightningkite/reactive/extensions/WaitForNotNull.mjs';
import { isBlank1dvkhjjvox3p0 as isBlank } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { Page1o437w9xuocrm as Page } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
import { CanBlockBacknswc7za76703 as CanBlockBack } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/CanBlockBack.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function reviewActionBar($this, $receiver) {
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (RowOrCol())($receiver.get_context_h02k06_k$());
  ensureOutermostElement(element);
  $receiver.willAddChild_hz2iwc_k$(element);
  element.set_vertical_nuap32_k$(false);
  // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
  var this_0 = themed(element, DangerTextSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  var this_1 = themed(this_0, ButtonSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_0 = new (Button())(this_1.get_context_h02k06_k$());
  ensureOutermostElement(element_0);
  this_1.willAddChild_hz2iwc_k$(element_0);
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_1 = new (TextView())(element_0.get_context_h02k06_k$());
  ensureOutermostElement(element_1);
  element_0.willAddChild_hz2iwc_k$(element_1);
  var tmp = KMutableProperty0();
  var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_1);
  var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_1));
  element_1.invoke_bnq13k_k$(tmp_1, ProviderApplicationDetailPage$reviewActionBar$lambda);
  element_1.onStartup_vrxh3i_k$();
  element_0.addChild_2qpft2_k$(element_1);
  var tmp_2 = KMutableProperty0();
  var tmp_3 = Button$_get_enabled_$ref_61t7nx(element_0);
  var tmp_4 = getPropertyCallableRef('enabled', 0, tmp_2, tmp_3, Button$_set_enabled_$ref_o8kynz(element_0));
  element_0.invoke_bnq13k_k$(tmp_4, ($this$invoke) => $this$invoke.invoke_r7m7el_k$($this.application_1).review_1 == null);
  element_0.set_action_2ds022_k$(Action('Cancel application', VOID, VOID, VOID, VOID, VOID, ProviderApplicationDetailPage$reviewActionBar$slambda(element_0, $this)));
  element_0.onStartup_vrxh3i_k$();
  this_1.addChild_2qpft2_k$(element_0);
  // Inline function 'com.lightningkite.kiteui.views.expanding' call
  // Inline function 'com.lightningkite.kiteui.views.direct.space' call
  var this_2 = weight(element, 1.0);
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_2 = new (Space())(this_2.get_context_h02k06_k$());
  ensureOutermostElement(element_2);
  this_2.willAddChild_hz2iwc_k$(element_2);
  element_2.onStartup_vrxh3i_k$();
  this_2.addChild_2qpft2_k$(element_2);
  // Inline function 'com.lightningkite.kiteui.views.important' call
  // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
  var this_3 = themed(element, ImportantSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  var this_4 = themed(this_3, ButtonSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_3 = new (Button())(this_4.get_context_h02k06_k$());
  ensureOutermostElement(element_3);
  this_4.willAddChild_hz2iwc_k$(element_3);
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_4 = new (TextView())(element_3.get_context_h02k06_k$());
  ensureOutermostElement(element_4);
  element_3.willAddChild_hz2iwc_k$(element_4);
  var tmp_5 = KMutableProperty0();
  var tmp_6 = TextView$_get_content_$ref_4pzcwl(element_4);
  var tmp_7 = getPropertyCallableRef('content', 0, tmp_5, tmp_6, TextView$_set_content_$ref_pketfb(element_4));
  element_4.invoke_bnq13k_k$(tmp_7, ProviderApplicationDetailPage$reviewActionBar$lambda_0);
  element_4.onStartup_vrxh3i_k$();
  element_3.addChild_2qpft2_k$(element_4);
  var tmp_8 = KMutableProperty0();
  var tmp_9 = Button$_get_enabled_$ref_61t7nx(element_3);
  var tmp_10 = getPropertyCallableRef('enabled', 0, tmp_8, tmp_9, Button$_set_enabled_$ref_o8kynz(element_3));
  element_3.invoke_bnq13k_k$(tmp_10, ($this$invoke) => !($this$invoke.invoke_r7m7el_k$($this.application_1).submission_1 == null) && $this$invoke.invoke_r7m7el_k$($this.application_1).review_1 == null);
  element_3.set_action_2ds022_k$(Action('Approve application', VOID, VOID, VOID, VOID, VOID, ProviderApplicationDetailPage$reviewActionBar$slambda_0(element_3, $this)));
  element_3.onStartup_vrxh3i_k$();
  this_4.addChild_2qpft2_k$(element_3);
  element.onStartup_vrxh3i_k$();
  $receiver.addChild_2qpft2_k$(element);
}
function submissionActionBar($this, $receiver) {
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (RowOrCol())($receiver.get_context_h02k06_k$());
  ensureOutermostElement(element);
  $receiver.willAddChild_hz2iwc_k$(element);
  element.set_vertical_nuap32_k$(false);
  // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  var this_0 = themed(element, ButtonSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_0 = new (Button())(this_0.get_context_h02k06_k$());
  ensureOutermostElement(element_0);
  this_0.willAddChild_hz2iwc_k$(element_0);
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_1 = new (TextView())(element_0.get_context_h02k06_k$());
  ensureOutermostElement(element_1);
  element_0.willAddChild_hz2iwc_k$(element_1);
  var tmp = KMutableProperty0();
  var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_1);
  var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_1));
  element_1.invoke_bnq13k_k$(tmp_1, ProviderApplicationDetailPage$submissionActionBar$lambda);
  element_1.onStartup_vrxh3i_k$();
  element_0.addChild_2qpft2_k$(element_1);
  onClick(element_0, VOID, VOID, VOID, ProviderApplicationDetailPage$submissionActionBar$slambda($this, element_0));
  element_0.onStartup_vrxh3i_k$();
  this_0.addChild_2qpft2_k$(element_0);
  // Inline function 'com.lightningkite.kiteui.views.expanding' call
  // Inline function 'com.lightningkite.kiteui.views.direct.space' call
  var this_1 = weight(element, 1.0);
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_2 = new (Space())(this_1.get_context_h02k06_k$());
  ensureOutermostElement(element_2);
  this_1.willAddChild_hz2iwc_k$(element_2);
  element_2.onStartup_vrxh3i_k$();
  this_1.addChild_2qpft2_k$(element_2);
  // Inline function 'com.lightningkite.kiteui.views.important' call
  // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
  var this_2 = themed(element, ImportantSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  var this_3 = themed(this_2, ButtonSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_3 = new (Button())(this_3.get_context_h02k06_k$());
  ensureOutermostElement(element_3);
  this_3.willAddChild_hz2iwc_k$(element_3);
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_4 = new (TextView())(element_3.get_context_h02k06_k$());
  ensureOutermostElement(element_4);
  element_3.willAddChild_hz2iwc_k$(element_4);
  var tmp_2 = KMutableProperty0();
  var tmp_3 = TextView$_get_content_$ref_4pzcwl(element_4);
  var tmp_4 = getPropertyCallableRef('content', 0, tmp_2, tmp_3, TextView$_set_content_$ref_pketfb(element_4));
  element_4.invoke_bnq13k_k$(tmp_4, ProviderApplicationDetailPage$submissionActionBar$lambda_0);
  element_4.onStartup_vrxh3i_k$();
  element_3.addChild_2qpft2_k$(element_4);
  element_3.set_action_2ds022_k$(Action('Submit', VOID, VOID, VOID, VOID, VOID, ProviderApplicationDetailPage$submissionActionBar$slambda_0($this, element_3)));
  element_3.onStartup_vrxh3i_k$();
  this_3.addChild_2qpft2_k$(element_3);
  element.onStartup_vrxh3i_k$();
  $receiver.addChild_2qpft2_k$(element);
}
function ProviderApplicationDetailPage$render$lambda($this$shownWhen) {
  return $this$shownWhen.invoke_r7m7el_k$($this$shownWhen.invoke_r7m7el_k$(get_currentSessionNotNull()).isAdmin_1);
}
function ProviderApplicationDetailPage$render$lambda_0($this$keyValue) {
  return $this$keyValue.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_providerApplicationSentToLabel_fc0az9_k$();
}
function ProviderApplicationDetailPage$render$lambda_1($this$keyValue) {
  return 'Sent at';
}
function ProviderApplicationDetailPage$render$lambda_2($this$inlineLabel) {
  return $this$inlineLabel.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_providerApplicationStatusLabel_tfhqmk_k$();
}
function ProviderApplicationDetailPage$render$lambda_3($this$keyValue) {
  return 'Submitted at';
}
function ProviderApplicationDetailPage$render$lambda_4($this$styledHeader) {
  return 'Submission';
}
function ProviderApplicationDetailPage$render$lambda_5($this$invoke) {
  return 'Not submitted';
}
function ProviderApplicationDetailPage$render$lambda_6($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_providerDetailsHeading_vbtsje_k$();
}
function ProviderApplicationDetailPage$render$lambda_7($this$iconButton) {
  return 'Edit';
}
function ProviderApplicationDetailPage$render$lambda$slambda(this$0) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    yield* this$0.editMode_1.set_revjhg_k$(true, $completion);
    return Unit_instance;
  }), 0);
}
function ProviderApplicationDetailPage$render$lambda_8($this$reactiveLabel) {
  return $this$reactiveLabel.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_providerContactNameLabel_l558ot_k$();
}
function ProviderApplicationDetailPage$render$lambda_9($this$reactiveLabel) {
  return $this$reactiveLabel.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_providerContactEmailLabel_lc4wv2_k$();
}
function ProviderApplicationDetailPage$render$lambda_10($this$reactiveLabel) {
  return $this$reactiveLabel.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_providerContactPhoneLabel_umwegk_k$();
}
function ProviderApplicationDetailPage$render$lambda_11($this$shownWhen) {
  return get_current(Companion_instance).equals(Platform_Web_getInstance());
}
function ProviderApplicationDetailPage$reviewActionBar$lambda($this$invoke) {
  return 'Cancel application';
}
function ProviderApplicationDetailPage$reviewActionBar$slambda$lambda($this$confirmationDialog) {
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (TextView())($this$confirmationDialog.get_context_h02k06_k$());
  ensureOutermostElement(element);
  $this$confirmationDialog.willAddChild_hz2iwc_k$(element);
  var tmp = KMutableProperty0();
  var tmp_0 = TextView$_get_content_$ref_4pzcwl(element);
  var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element));
  element.invoke_bnq13k_k$(tmp_1, ProviderApplicationDetailPage$reviewActionBar$slambda$lambda$lambda);
  element.onStartup_vrxh3i_k$();
  $this$confirmationDialog.addChild_2qpft2_k$(element);
  return Unit_instance;
}
function ProviderApplicationDetailPage$reviewActionBar$slambda$lambda$lambda($this$invoke) {
  return 'This cannot be undone. To re-invite this provider, you will have to create a new invite.';
}
function ProviderApplicationDetailPage$reviewActionBar$slambda$slambda(this$0, $$this$button) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = get_currentSessionNotNull();
    var session = yield* await_0(this_0, $completion);
    var updated = yield* session.api_1.get_providerApplication_tefbxy_k$().reviewProviderApplication_fqhq7n_k$(new (ProviderApplicationReviewRequest())(this$0.id_1, new (Review())(VOID, false)), $completion);
    session.get_providerApplications_bz9fcz_k$().localInsert_9xyne_k$(updated);
    var tmp = $$this$button.get_context_h02k06_k$();
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = get_strings(AppState_getInstance());
    var tmp$ret$1 = yield* await_1(this_1, $completion);
    toast(tmp, tmp$ret$1.get_providerApplicationRejectedToast_8w30b1_k$());
    return Unit_instance;
  }), 0);
}
function ProviderApplicationDetailPage$reviewActionBar$slambda($$this$button, this$0) {
  return constructCallableReference(($this$Action, $completion) => orPromise($completion, function *($completion) {
    var tmp = $$this$button.get_context_h02k06_k$();
    var tmp_0 = ProviderApplicationDetailPage$reviewActionBar$slambda$lambda;
    var tmp_1 = DangerSemantic_getInstance();
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = get_strings(AppState_getInstance());
    var tmp_2 = (yield* await_1(this_0, $completion)).get_crudCancelButton_yk4tir_k$();
    confirmationDialog(tmp, 'Cancel application?', tmp_0, 'Cancel application', tmp_1, tmp_2, VOID, ProviderApplicationDetailPage$reviewActionBar$slambda$slambda(this$0, $$this$button));
    return Unit_instance;
  }), 1);
}
function ProviderApplicationDetailPage$reviewActionBar$lambda_0($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_providerApplicationApproveButton_dxws6v_k$();
}
function ProviderApplicationDetailPage$reviewActionBar$slambda$lambda_0($this$confirmationDialog) {
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  var this_0 = get_bold($this$confirmationDialog);
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (TextView())(this_0.get_context_h02k06_k$());
  ensureOutermostElement(element);
  this_0.willAddChild_hz2iwc_k$(element);
  var tmp = KMutableProperty0();
  var tmp_0 = TextView$_get_content_$ref_4pzcwl(element);
  var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element));
  element.invoke_bnq13k_k$(tmp_1, ProviderApplicationDetailPage$reviewActionBar$slambda$lambda$lambda_0);
  element.onStartup_vrxh3i_k$();
  this_0.addChild_2qpft2_k$(element);
  return Unit_instance;
}
function ProviderApplicationDetailPage$reviewActionBar$slambda$lambda$lambda_0($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_providerApplicationApproveConfirmBody_o3mmdn_k$();
}
function ProviderApplicationDetailPage$reviewActionBar$slambda$slambda_0(this$0, $$this$button) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = get_currentSessionNotNull();
    var session = yield* await_0(this_0, $completion);
    var updated = yield* session.api_1.get_providerApplication_tefbxy_k$().reviewProviderApplication_fqhq7n_k$(new (ProviderApplicationReviewRequest())(this$0.id_1, new (Review())(VOID, true)), $completion);
    session.get_providerApplications_bz9fcz_k$().localInsert_9xyne_k$(updated);
    var tmp0_safe_receiver = updated.review_1;
    var newProviderId = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.resultingProvider_1;
    var tmp = $$this$button.get_context_h02k06_k$();
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = get_strings(AppState_getInstance());
    var tmp$ret$1 = yield* await_1(this_1, $completion);
    toast(tmp, tmp$ret$1.get_providerApplicationApprovedToast_1ndkpm_k$());
    var tmp_0;
    var tmp_1 = newProviderId;
    if (!((tmp_1 == null ? null : new (ID_0())(tmp_1)) == null)) {
      get_pageNavigator($$this$button.get_context_h02k06_k$()).reset_diztr_k$(new (ProviderDetailPage())(newProviderId));
      tmp_0 = Unit_instance;
    }
    return Unit_instance;
  }), 0);
}
function ProviderApplicationDetailPage$reviewActionBar$slambda_0($$this$button, this$0) {
  return constructCallableReference(($this$Action, $completion) => orPromise($completion, function *($completion) {
    var tmp = $$this$button.get_context_h02k06_k$();
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = get_strings(AppState_getInstance());
    var tmp_0 = (yield* await_1(this_0, $completion)).get_providerApplicationApproveConfirmHeading_ifddmh_k$();
    var tmp_1 = ProviderApplicationDetailPage$reviewActionBar$slambda$lambda_0;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = get_strings(AppState_getInstance());
    var tmp_2 = (yield* await_1(this_1, $completion)).get_providerApplicationApproveButton_dxws6v_k$();
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_2 = get_strings(AppState_getInstance());
    var tmp_3 = (yield* await_1(this_2, $completion)).get_crudCancelButton_yk4tir_k$();
    confirmationDialog(tmp, tmp_0, tmp_1, tmp_2, VOID, tmp_3, VOID, ProviderApplicationDetailPage$reviewActionBar$slambda$slambda_0(this$0, $$this$button));
    return Unit_instance;
  }), 1);
}
function ProviderApplicationDetailPage$submissionActionBar$lambda($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_crudCancelButton_yk4tir_k$();
}
function ProviderApplicationDetailPage$submissionActionBar$slambda(this$0, $$this$button) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    this$0.application_1.cancel_2l89ey_k$();
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = get_currentSessionNotNull();
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = (yield* await_0(this_0, $completion)).isAdmin_1;
    if (yield* await_0(this_1, $completion)) {
      yield* this$0.editMode_1.set_revjhg_k$(false, $completion);
    } else {
      get_pageNavigator($$this$button.get_context_h02k06_k$()).goBack_kj7lzl_k$();
    }
    return Unit_instance;
  }), 0);
}
function ProviderApplicationDetailPage$submissionActionBar$lambda_0($this$invoke) {
  return 'Submit';
}
function ProviderApplicationDetailPage$submissionActionBar$slambda$lambda($this$confirmationDialog) {
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (TextView())($this$confirmationDialog.get_context_h02k06_k$());
  ensureOutermostElement(element);
  $this$confirmationDialog.willAddChild_hz2iwc_k$(element);
  var tmp = KMutableProperty0();
  var tmp_0 = TextView$_get_content_$ref_4pzcwl(element);
  var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element));
  element.invoke_bnq13k_k$(tmp_1, ProviderApplicationDetailPage$submissionActionBar$slambda$lambda$lambda);
  element.onStartup_vrxh3i_k$();
  $this$confirmationDialog.addChild_2qpft2_k$(element);
  return Unit_instance;
}
function ProviderApplicationDetailPage$submissionActionBar$slambda$lambda$lambda($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$($this$invoke.invoke_r7m7el_k$(get_currentSessionNotNull()).isAdmin_1) ? 'This will update the application submission.' : 'The application will be sent to TCG.';
}
function ProviderApplicationDetailPage$submissionActionBar$slambda$slambda(this$0, $$this$button) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = get_currentSessionNotNull();
    var session = yield* await_0(this_0, $completion);
    var tmp;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = this$0.application_1.get_published_wg9pad_k$();
    if ((yield* await_0(this_1, $completion)).submission_1 == null) {
      var tmp_0 = session.api_1.get_providerApplication_tefbxy_k$();
      // Inline function 'com.lightningkite.reactive.context.invoke' call
      var this_2 = this$0.submissionLens_1;
      var tmp$ret$2 = yield* await_0(this_2, $completion);
      tmp = yield* tmp_0.submitProviderApplication_m4mzkd_k$(new (ProviderApplicationSubmitRequest())(this$0.id_1, tmp$ret$2), $completion);
    } else {
      var tmp_1 = session.get_providerApplications_bz9fcz_k$().get_6ueaa7_k$(new (ID())(this$0.id_1));
      // Inline function 'com.lightningkite.services.database.modification' call
      // Inline function 'kotlin.apply' call
      var this_3 = new (ModificationBuilder())();
      // Inline function 'com.lightningkite.services.database.path' call
      // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
      var tmp_2 = serializerOrContextual(createKType(getKClass(ProviderApplication()), arrayOf([]), false));
      var tmp$ret$7 = isInterface(tmp_2, KSerializer()) ? tmp_2 : THROW_CCE();
      var it = new (DataClassPathSelf())(tmp$ret$7);
      var tmp_3 = get_submission(it);
      // Inline function 'com.lightningkite.reactive.context.invoke' call
      var this_4 = this$0.submissionLens_1;
      var tmp$ret$9 = yield* await_0(this_4, $completion);
      this_3.assign_vtsfu6_k$(tmp_3, tmp$ret$9);
      var tmp$ret$3 = this_3.build_1k0s4u_k$();
      tmp = yield* tmp_1.modify_ff53f_k$(tmp$ret$3, $completion);
    }
    var tmp0_elvis_lhs = tmp;
    var tmp_4;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp_4 = tmp0_elvis_lhs;
    }
    var updated = tmp_4;
    yield* session.get_providerApplications_bz9fcz_k$().totallyInvalidate_d4stw5_k$($completion);
    session.get_providerApplications_bz9fcz_k$().localInsert_9xyne_k$(updated);
    yield* this$0.application_1.publish_xq9q2e_k$($completion);
    yield* this$0.editMode_1.set_revjhg_k$(false, $completion);
    var tmp_5 = $$this$button.get_context_h02k06_k$();
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_5 = get_strings(AppState_getInstance());
    var tmp$ret$10 = yield* await_1(this_5, $completion);
    toast(tmp_5, tmp$ret$10.get_providerSavedToast_yjdohm_k$());
    return Unit_instance;
  }), 0);
}
function ProviderApplicationDetailPage$submissionActionBar$slambda_0(this$0, $$this$button) {
  return constructCallableReference(($this$Action, $completion) => orPromise($completion, function *($completion) {
    var tmp;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = get_issues(this$0.application_1);
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!(yield* await_0(this_0, $completion)).isEmpty_y1axqb_k$()) {
      yield* this$0.get_showValidation_c0zzxd_k$().set_revjhg_k$(true, $completion);
      this$0.formIssuesDialog$default_8ey6bo_k$($$this$button.get_context_h02k06_k$());
      return Unit_instance;
    }
    var tmp_0 = $$this$button.get_context_h02k06_k$();
    var tmp_1 = ProviderApplicationDetailPage$submissionActionBar$slambda$lambda;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = get_strings(AppState_getInstance());
    var tmp_2 = (yield* await_1(this_1, $completion)).get_crudCancelButton_yk4tir_k$();
    confirmationDialog(tmp_0, 'Submit application', tmp_1, 'Submit', VOID, tmp_2, VOID, ProviderApplicationDetailPage$submissionActionBar$slambda$slambda(this$0, $$this$button));
    return Unit_instance;
  }), 1);
}
var ProviderApplicationDetailPageClass;
function ProviderApplicationDetailPage() {
  if (ProviderApplicationDetailPageClass === VOID) {
    class $ extends Form() {
      constructor(id) {
        super();
        this.id_1 = id;
        var tmp = this;
        tmp.application_1 = validated(Draft(($this$Draft) => $this$Draft.awaitNotNull_2lqt5h_k$($this$Draft.invoke_r7m7el_k$(get_currentSessionNotNull()).get_providerApplications_bz9fcz_k$().get_6ueaa7_k$(new (ID())(this.id_1)))));
        var tmp_0 = this;
        // Inline function 'com.lightningkite.serialization.lensPath' call
        var this_0 = this.application_1;
        // Inline function 'com.lightningkite.services.database.path' call
        // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
        var tmp_1 = serializerOrContextual(createKType(getKClass(ProviderApplication()), arrayOf([]), false));
        var tmp$ret$2 = isInterface(tmp_1, KSerializer()) ? tmp_1 : THROW_CCE();
        var it = new (DataClassPathSelf())(tmp$ret$2);
        var tmp$ret$3 = get_submission(it);
        var tmp$ret$0 = lensPath(this_0, tmp$ret$3);
        tmp_0.submissionLens_1 = notNull(tmp$ret$0, new (Submission())(VOID, new (CareProvider())(VOID, '')));
        var tmp_2 = this;
        tmp_2.editMode_1 = mutableRemember(VOID, VOID, ($this$mutableRemember) => $this$mutableRemember.invoke_r7m7el_k$(this.application_1.get_published_wg9pad_k$()).submission_1 == null && !$this$mutableRemember.invoke_r7m7el_k$($this$mutableRemember.invoke_r7m7el_k$(get_currentSessionNotNull()).isAdmin_1));
      }
      get_title_iz32un_k$() {
        return remember(VOID, VOID, VOID, VOID, ($this$remember) => $this$remember.invoke_r7m7el_k$(get_strings(AppState_getInstance())).providerApplicationDetailTitle_7oej8u_k$(EmailAddress__toString_impl_artjh3($this$remember.invoke_r7m7el_k$(this.application_1).sentTo_1)));
      }
      onNavigateAwayAttempt_vrrtsh_k$() {
        return !(ReactiveState__getOrNull_impl_1asnfp(this.application_1.get_changesMade_d6j01d_k$().get_state_wc71uu_k$()) === true);
      }
      render_w3x9d1_k$(_this__u8e3s4) {
        // Inline function 'org.thecommunitygroupinc.cares.views.components.page' call
        var this_0 = get_scrolling(_this__u8e3s4);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_1 = maxWidth(this_0);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element = new (RowOrCol())(this_1.get_context_h02k06_k$());
        ensureOutermostElement(element);
        this_1.willAddChild_hz2iwc_k$(element);
        element.set_vertical_nuap32_k$(true);
        element.set_themeBase_daz04n_k$(Companion_getInstance().fromParentNonCascading_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_0 = new (RowOrCol())(element.get_context_h02k06_k$());
        ensureOutermostElement(element_0);
        element.willAddChild_hz2iwc_k$(element_0);
        element_0.set_vertical_nuap32_k$(false);
        goBackButton(get_centered(element_0));
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        var this_2 = get_centered(element_0);
        // Inline function 'com.lightningkite.kiteui.views.direct.h1' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        var this_3 = weight(this_2, 1.0);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_1 = new (TextView())(this_3.get_context_h02k06_k$());
        ensureOutermostElement(element_1);
        this_3.willAddChild_hz2iwc_k$(element_1);
        element_1.set_themeChoice_py59um_k$(element_1.get_themeChoice_22tyn3_k$().plus_duvq05_k$(HeaderSemantic_getInstance().plus_duvq05_k$(get_H1Semantic())));
        var tmp = KMutableProperty0();
        var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_1);
        var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_1));
        element_1.invoke_bnq13k_k$(tmp_1, ($this$invoke) => $this$invoke.invoke_r7m7el_k$(this.get_title_iz32un_k$()));
        element_1.onStartup_vrxh3i_k$();
        this_3.addChild_2qpft2_k$(element_1);
        element_0.onStartup_vrxh3i_k$();
        element.addChild_2qpft2_k$(element_0);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_4 = shownWhen(element, VOID, VOID, ($this$shownWhen) => $this$shownWhen.invoke_r7m7el_k$(this.editMode_1));
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_2 = new (RowOrCol())(this_4.get_context_h02k06_k$());
        ensureOutermostElement(element_2);
        this_4.willAddChild_hz2iwc_k$(element_2);
        element_2.set_vertical_nuap32_k$(true);
        // Inline function 'com.lightningkite.kiteui.views.direct.separator' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_3 = new (Separator())(element_2.get_context_h02k06_k$());
        ensureOutermostElement(element_3);
        element_2.willAddChild_hz2iwc_k$(element_3);
        element_3.onStartup_vrxh3i_k$();
        element_2.addChild_2qpft2_k$(element_3);
        submissionActionBar(this, element_2);
        // Inline function 'com.lightningkite.serialization.lensPath' call
        var this_5 = this.submissionLens_1;
        // Inline function 'com.lightningkite.services.database.path' call
        // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
        var tmp_2 = serializerOrContextual(createKType(getKClass(Submission()), arrayOf([]), false));
        var tmp$ret$25 = isInterface(tmp_2, KSerializer()) ? tmp_2 : THROW_CCE();
        var it = new (DataClassPathSelf())(tmp$ret$25);
        var tmp$ret$26 = get_provider(it);
        var tmp$ret$23 = lensPath_0(this_5, tmp$ret$26);
        providerForm(this, element_2, validated_0(tmp$ret$23), true);
        // Inline function 'com.lightningkite.kiteui.views.direct.separator' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_4 = new (Separator())(element_2.get_context_h02k06_k$());
        ensureOutermostElement(element_4);
        element_2.willAddChild_hz2iwc_k$(element_4);
        element_4.onStartup_vrxh3i_k$();
        element_2.addChild_2qpft2_k$(element_4);
        submissionActionBar(this, element_2);
        element_2.onStartup_vrxh3i_k$();
        this_4.addChild_2qpft2_k$(element_2);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_6 = shownWhen(element, VOID, VOID, ($this$shownWhen) => !$this$shownWhen.invoke_r7m7el_k$(this.editMode_1));
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_5 = new (RowOrCol())(this_6.get_context_h02k06_k$());
        ensureOutermostElement(element_5);
        this_6.willAddChild_hz2iwc_k$(element_5);
        element_5.set_vertical_nuap32_k$(true);
        // Inline function 'com.lightningkite.kiteui.views.card' call
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_7 = themed(element_5, CardSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_6 = new (RowOrCol())(this_7.get_context_h02k06_k$());
        ensureOutermostElement(element_6);
        this_7.willAddChild_hz2iwc_k$(element_6);
        element_6.set_vertical_nuap32_k$(true);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_8 = shownWhen(element_6, VOID, VOID, ProviderApplicationDetailPage$render$lambda);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_7 = new (RowOrCol())(this_8.get_context_h02k06_k$());
        ensureOutermostElement(element_7);
        this_8.willAddChild_hz2iwc_k$(element_7);
        element_7.set_vertical_nuap32_k$(true);
        var tmp_3 = ProviderApplicationDetailPage$render$lambda_0;
        keyValue(element_7, tmp_3, ($this$keyValue) => EmailAddress__toString_impl_artjh3($this$keyValue.invoke_r7m7el_k$(this.application_1).sentTo_1));
        var tmp_4 = ProviderApplicationDetailPage$render$lambda_1;
        keyValue(element_7, tmp_4, ($this$keyValue) => renderToString($this$keyValue.invoke_r7m7el_k$(this.application_1).createdAt_1));
        element_7.onStartup_vrxh3i_k$();
        this_8.addChild_2qpft2_k$(element_7);
        // Inline function 'org.thecommunitygroupinc.cares.views.components.inlineLabel' call
        var label = ProviderApplicationDetailPage$render$lambda_2;
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_8 = new (RowOrCol())(element_6.get_context_h02k06_k$());
        ensureOutermostElement(element_8);
        element_6.willAddChild_hz2iwc_k$(element_8);
        element_8.set_vertical_nuap32_k$(false);
        // Inline function 'com.lightningkite.kiteui.views.direct.subtext' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        var this_9 = sizeConstraints(get_centered(element_8), VOID, VOID, VOID, VOID, VOID, get_rem(10));
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_9 = new (TextView())(this_9.get_context_h02k06_k$());
        ensureOutermostElement(element_9);
        this_9.willAddChild_hz2iwc_k$(element_9);
        element_9.set_themeChoice_py59um_k$(element_9.get_themeChoice_22tyn3_k$().plus_duvq05_k$(SubtextSemantic_getInstance()));
        var tmp_5 = KMutableProperty0();
        var tmp_6 = TextView$_get_content_$ref_4pzcwl(element_9);
        var tmp_7 = getPropertyCallableRef('content', 0, tmp_5, tmp_6, TextView$_set_content_$ref_pketfb(element_9));
        element_9.invoke_bnq13k_k$(tmp_7, ($this$invoke) => label($this$invoke));
        element_9.onStartup_vrxh3i_k$();
        this_9.addChild_2qpft2_k$(element_9);
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        var this_10 = get_centered(element_8);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        var this_11 = weight(this_10, 1.0);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_10 = new (RowOrCol())(this_11.get_context_h02k06_k$());
        ensureOutermostElement(element_10);
        this_11.willAddChild_hz2iwc_k$(element_10);
        element_10.set_vertical_nuap32_k$(false);
        var tmp_8 = themed(element_10, ChipSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        var this_12 = dynamicThemed(tmp_8, ($this$dynamicThemed) => {
          var tmp;
          var tmp0_safe_receiver = $this$dynamicThemed.invoke_r7m7el_k$(this.application_1).review_1;
          if ((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.approved_1) === true) {
            tmp = AffirmativeSemantic_getInstance();
          } else {
            var tmp1_safe_receiver = $this$dynamicThemed.invoke_r7m7el_k$(this.application_1).review_1;
            if ((tmp1_safe_receiver == null ? null : tmp1_safe_receiver.approved_1) === false) {
              tmp = DangerSemantic_getInstance();
            } else {
              if ($this$dynamicThemed.invoke_r7m7el_k$(this.application_1).submission_1 == null) {
                tmp = null;
              } else {
                tmp = WarningSemantic_getInstance();
              }
            }
          }
          return tmp;
        });
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_11 = new (TextView())(this_12.get_context_h02k06_k$());
        ensureOutermostElement(element_11);
        this_12.willAddChild_hz2iwc_k$(element_11);
        var tmp_9 = KMutableProperty0();
        var tmp_10 = TextView$_get_content_$ref_4pzcwl(element_11);
        var tmp_11 = getPropertyCallableRef('content', 0, tmp_9, tmp_10, TextView$_set_content_$ref_pketfb(element_11));
        element_11.invoke_bnq13k_k$(tmp_11, ($this$invoke) => {
          var tmp;
          var tmp0_safe_receiver = $this$invoke.invoke_r7m7el_k$(this.application_1).review_1;
          if ((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.approved_1) === true) {
            tmp = 'Approved';
          } else {
            var tmp1_safe_receiver = $this$invoke.invoke_r7m7el_k$(this.application_1).review_1;
            if ((tmp1_safe_receiver == null ? null : tmp1_safe_receiver.approved_1) === false) {
              tmp = 'Cancelled';
            } else {
              if ($this$invoke.invoke_r7m7el_k$(this.application_1).submission_1 == null) {
                tmp = 'Invited';
              } else {
                tmp = 'Submitted';
              }
            }
          }
          return tmp;
        });
        element_11.onStartup_vrxh3i_k$();
        this_12.addChild_2qpft2_k$(element_11);
        element_10.onStartup_vrxh3i_k$();
        this_11.addChild_2qpft2_k$(element_10);
        element_8.onStartup_vrxh3i_k$();
        element_6.addChild_2qpft2_k$(element_8);
        var tmp_12 = ProviderApplicationDetailPage$render$lambda_3;
        keyValue(element_6, tmp_12, ($this$keyValue) => {
          var tmp0_safe_receiver = $this$keyValue.invoke_r7m7el_k$(this.application_1).submission_1;
          var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.submittedAt_1;
          var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.at_1;
          var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : renderToString(tmp2_safe_receiver);
          return tmp3_elvis_lhs == null ? $this$keyValue.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_providerApplicationNotSubmittedLabel_wjkrfa_k$() : tmp3_elvis_lhs;
        });
        element_6.onStartup_vrxh3i_k$();
        this_7.addChild_2qpft2_k$(element_6);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_12 = new (Space())(element_5.get_context_h02k06_k$());
        ensureOutermostElement(element_12);
        element_5.willAddChild_hz2iwc_k$(element_12);
        element_12.onStartup_vrxh3i_k$();
        element_5.addChild_2qpft2_k$(element_12);
        styledHeader(element_5, ProviderApplicationDetailPage$render$lambda_4);
        // Inline function 'com.lightningkite.kiteui.views.card' call
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_13 = themed(element_5, CardSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_13 = new (RowOrCol())(this_13.get_context_h02k06_k$());
        ensureOutermostElement(element_13);
        this_13.willAddChild_hz2iwc_k$(element_13);
        element_13.set_vertical_nuap32_k$(true);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        var this_14 = shownWhen(element_13, VOID, VOID, ($this$shownWhen) => $this$shownWhen.invoke_r7m7el_k$(this.application_1).submission_1 == null);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_14 = new (RowOrCol())(this_14.get_context_h02k06_k$());
        ensureOutermostElement(element_14);
        this_14.willAddChild_hz2iwc_k$(element_14);
        element_14.set_vertical_nuap32_k$(false);
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        var this_15 = themed(element_14, ChipSemantic_getInstance().plus_duvq05_k$(WarningSemantic_getInstance()));
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_15 = new (TextView())(this_15.get_context_h02k06_k$());
        ensureOutermostElement(element_15);
        this_15.willAddChild_hz2iwc_k$(element_15);
        var tmp_13 = KMutableProperty0();
        var tmp_14 = TextView$_get_content_$ref_4pzcwl(element_15);
        var tmp_15 = getPropertyCallableRef('content', 0, tmp_13, tmp_14, TextView$_set_content_$ref_pketfb(element_15));
        element_15.invoke_bnq13k_k$(tmp_15, ProviderApplicationDetailPage$render$lambda_5);
        element_15.onStartup_vrxh3i_k$();
        this_15.addChild_2qpft2_k$(element_15);
        element_14.onStartup_vrxh3i_k$();
        this_14.addChild_2qpft2_k$(element_14);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_16 = shownWhen(element_13, VOID, VOID, ($this$shownWhen) => !($this$shownWhen.invoke_r7m7el_k$(this.application_1.get_published_wg9pad_k$()).submission_1 == null));
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_16 = new (RowOrCol())(this_16.get_context_h02k06_k$());
        ensureOutermostElement(element_16);
        this_16.willAddChild_hz2iwc_k$(element_16);
        element_16.set_vertical_nuap32_k$(true);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_17 = new (RowOrCol())(element_16.get_context_h02k06_k$());
        ensureOutermostElement(element_17);
        element_16.willAddChild_hz2iwc_k$(element_17);
        element_17.set_vertical_nuap32_k$(false);
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        var this_17 = get_atBottomCenter(element_17);
        var tmp$ret$85 = weight(this_17, 1.0);
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        var this_18 = get_bold(tmp$ret$85);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_18 = new (TextView())(this_18.get_context_h02k06_k$());
        ensureOutermostElement(element_18);
        this_18.willAddChild_hz2iwc_k$(element_18);
        var tmp_16 = KMutableProperty0();
        var tmp_17 = TextView$_get_content_$ref_4pzcwl(element_18);
        var tmp_18 = getPropertyCallableRef('content', 0, tmp_16, tmp_17, TextView$_set_content_$ref_pketfb(element_18));
        element_18.invoke_bnq13k_k$(tmp_18, ProviderApplicationDetailPage$render$lambda_6);
        element_18.onStartup_vrxh3i_k$();
        this_18.addChild_2qpft2_k$(element_18);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_19 = shownWhen(element_17, VOID, VOID, ($this$shownWhen) => $this$shownWhen.invoke_r7m7el_k$($this$shownWhen.invoke_r7m7el_k$(get_currentSessionNotNull()).isAdmin_1) && $this$shownWhen.invoke_r7m7el_k$(this.application_1).review_1 == null);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_19 = new (RowOrCol())(this_19.get_context_h02k06_k$());
        ensureOutermostElement(element_19);
        this_19.willAddChild_hz2iwc_k$(element_19);
        element_19.set_vertical_nuap32_k$(true);
        var tmp_19 = get_edit(Companion_getInstance_0());
        var tmp_20 = ProviderApplicationDetailPage$render$lambda_7;
        iconButton(element_19, tmp_19, tmp_20, ($this$iconButton) => {
          onClick($this$iconButton, VOID, VOID, VOID, ProviderApplicationDetailPage$render$lambda$slambda(this));
          return Unit_instance;
        });
        element_19.onStartup_vrxh3i_k$();
        this_19.addChild_2qpft2_k$(element_19);
        element_17.onStartup_vrxh3i_k$();
        element_16.addChild_2qpft2_k$(element_17);
        var p = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
          var tmp0_safe_receiver = $this$remember.invoke_r7m7el_k$(this.application_1.get_published_wg9pad_k$()).submission_1;
          return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.provider_1;
        });
        var provider = get_waitForNotNull(p);
        var tmp_21 = ProviderApplicationDetailPage$render$lambda_8;
        reactiveLabel(element_16, tmp_21, ($this$reactiveLabel) => {
          // Inline function 'kotlin.text.ifBlank' call
          var this_0 = $this$reactiveLabel.invoke_r7m7el_k$(provider).contact_1.name_1;
          var tmp;
          if (isBlank(this_0)) {
            tmp = '[Not set]';
          } else {
            tmp = this_0;
          }
          return tmp;
        });
        var tmp_22 = ProviderApplicationDetailPage$render$lambda_9;
        reactiveLabel(element_16, tmp_22, ($this$reactiveLabel) => {
          var tmp0_safe_receiver = $this$reactiveLabel.invoke_r7m7el_k$(provider).contact_1.email_1;
          var tmp;
          var tmp_0 = tmp0_safe_receiver;
          if ((tmp_0 == null ? null : new (EmailAddress())(tmp_0)) == null) {
            tmp = null;
          } else {
            tmp = EmailAddress__toString_impl_artjh3(tmp0_safe_receiver);
          }
          var tmp1_elvis_lhs = tmp;
          return tmp1_elvis_lhs == null ? '[Not set]' : tmp1_elvis_lhs;
        });
        var tmp_23 = ProviderApplicationDetailPage$render$lambda_10;
        reactiveLabel(element_16, tmp_23, ($this$reactiveLabel) => {
          var tmp0_safe_receiver = $this$reactiveLabel.invoke_r7m7el_k$(provider).contact_1.phone_1;
          var tmp;
          var tmp_0 = tmp0_safe_receiver;
          if ((tmp_0 == null ? null : new (PhoneNumber())(tmp_0)) == null) {
            tmp = null;
          } else {
            tmp = PhoneNumber__toString_impl_7i2x3q(tmp0_safe_receiver);
          }
          var tmp1_elvis_lhs = tmp;
          return tmp1_elvis_lhs == null ? '[Not set]' : tmp1_elvis_lhs;
        });
        element_16.onStartup_vrxh3i_k$();
        this_16.addChild_2qpft2_k$(element_16);
        element_13.onStartup_vrxh3i_k$();
        this_13.addChild_2qpft2_k$(element_13);
        element_5.onStartup_vrxh3i_k$();
        this_6.addChild_2qpft2_k$(element_5);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_20 = new (Space())(element.get_context_h02k06_k$());
        ensureOutermostElement(element_20);
        element.willAddChild_hz2iwc_k$(element_20);
        element_20.onStartup_vrxh3i_k$();
        element.addChild_2qpft2_k$(element_20);
        reviewActionBar(this, shownWhen(element, VOID, VOID, ($this$shownWhen) => $this$shownWhen.invoke_r7m7el_k$($this$shownWhen.invoke_r7m7el_k$(get_currentSessionNotNull()).isAdmin_1) && !$this$shownWhen.invoke_r7m7el_k$(this.editMode_1)));
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        var this_20 = shownWhen(element, VOID, VOID, ProviderApplicationDetailPage$render$lambda_11);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_21 = new (Space())(this_20.get_context_h02k06_k$(), 1.0);
        ensureOutermostElement(element_21);
        this_20.willAddChild_hz2iwc_k$(element_21);
        element_21.onStartup_vrxh3i_k$();
        this_20.addChild_2qpft2_k$(element_21);
        element.onStartup_vrxh3i_k$();
        this_1.addChild_2qpft2_k$(element);
        return Unit_instance;
      }
    }
    initMetadataForClass($, 'ProviderApplicationDetailPage', VOID, VOID, [Page(), CanBlockBack()]);
    ProviderApplicationDetailPageClass = $;
  }
  return ProviderApplicationDetailPageClass;
}
//region block: exports
export {
  ProviderApplicationDetailPage as ProviderApplicationDetailPage2kxg2k1w3bu5h,
};
//endregion

//# sourceMappingURL=ProviderApplicationDetailPage.mjs.map
